// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-row[data-v-53b612fa] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  border: 1px solid var(--border-color);\n  margin-top: 2px;\n  margin-bottom: 2px;\n  border-radius: 5px !important;\n  font-size: 14px;\n}\n.table-header[data-v-53b612fa] {\n  padding: 5px;\n  font-weight: bold;\n  font-size: 14px;\n}", ""]);
// Exports
module.exports = exports;
